import { render, staticRenderFns } from "./authorization-success.vue?vue&type=template&id=1a9512cd&scoped=true&"
import script from "./authorization-success.vue?vue&type=script&lang=ts&"
export * from "./authorization-success.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9512cd",
  null
  
)

export default component.exports